module.exports = __webpack_public_path__ + "assets/img/img149.54b0b02d.png";